export default "__VITE_ASSET__BB1kh2kS__"